import socket from "@/services/socket";
import {
  usePlayersStore,
  useSessionStore,
} from "@/stores";
export function handleBye(playerId: string) {
  const session = useSessionStore();
  const playersStore = usePlayersStore();
  if (session.isPlayerOrSpectator) return;
  delete socket.players[playerId];
  delete socket.pings[playerId];
  const player = playersStore.getById(playerId);
  if (player) {
    playersStore.update({
      player,
      property: "id",
      value: "",
    });
  }
}
